import { CompanyStateEnum, PlanTypeEnum } from "./securityEnums";

export const companyStateEnumOptions = [
  { key: CompanyStateEnum.Active, text: "Activo" },
  { key: CompanyStateEnum.Inactive, text: "Inactivo" },
];

export const PlanTypeEnumOptions = [
  {
    key: PlanTypeEnum.Consumption,
    text: "Plan por consumo",
    value: PlanTypeEnum.Consumption,
  },
  {
    key: PlanTypeEnum.Package,
    text: "Plan por paquetes",
    value: PlanTypeEnum.Package,
  },
];

export const getCompanyStateEnum = (key: number) => {
  return (
    companyStateEnumOptions.find((type) => type.key === key)?.text ||
    "No se encontro el enumerador"
  );
};

export const getPlanTypeEnum = (key: number) => {
  return (
    PlanTypeEnumOptions.find((type) => type.key === key)?.text ||
    "No se encontro el enumerador"
  );
};
